const sessionMixin = {
  methods: {
    saveToLocalStorage (user) {
      localStorage.setItem('user', JSON.stringify(user))
    },
    getAuthUser () {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      if (userInfo) {
        return {
          email: userInfo.email,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          picture: userInfo.picture,
          token: userInfo.token,
          permissions: userInfo.permissions,
          role: userInfo.role
        }
      }
      return null
    },
    clear () {
      localStorage.clear()
    },
    hasPermission (permissionCode) {
      const user = this.getAuthUser()
      if (user) {
        return user.permissions.includes(permissionCode)
      }
      return false
    }
  }
}
export default sessionMixin
